/*
  Phase 29 — LabSureX (Pathology lab) ko HMS se kholna. PLAN.md Phase 29 ·
  API: Controllers/LabLinkController.cs · DatabaseScripts/LabLink/README.md

  ─────────────────────────────────────────────────────────────────────────────
  KAISE

    1. `POST /LabLink/ticket` (apne HMS token se) — server jaanchta hai ki lab judi hai,
       user ke paas Pathology hai, uska Lab role kya hai — aur 60 second ka ek-baar ka
       ticket SIGN karke deta hai.
    2. Browser wo ticket LabSureX ko FORM POST karta hai — naye tab me, jo HMS ka tab
       khula chhod deta hai. HMS ka token kabhi LabSureX nahi jaata.

  NAYA TAB PEHLE KYUN KHOLTE HAIN
    Popup blocker sirf wahi naya tab khulne deta hai jo click ke TURANT baad khule.
    Ticket aane me (await) waqt lagta hai — tab tak "click" beet chuka hota. Isliye tab
    click par hi khaali khulta hai, aur ticket aane par form usi tab me jaata hai.
    Script se khula tab hi LabSureX me "Hospital" dabane par khud band ho sakta hai.

  ⚠️ Ye sirf UI ka aaram hai. Asli rok server par hai — ticket endpoint aur LabSureX dono
     apni-apni jaanch karte hain. sessionStorage badal kar link dikh bhi jaaye to ticket
     nahi milega.
*/
import { customFetch } from "./apiClient";
import { readServerMessage } from "./tenancy";

const KEY = "labLinkEnabled";

// Login ke turant baad (Login.jsx) — server ne bataya lab judi hai ya nahi
export function saveLabLink(data) {
  try {
    sessionStorage.setItem(KEY, data?.labLinkEnabled ? "1" : "0");
  } catch {
    /* sessionStorage na mile to link nahi dikhega — server waise bhi rokta hai */
  }
}

export function labLinkEnabled() {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

function allowedModules() {
  try {
    const list = JSON.parse(sessionStorage.getItem("allowedModules") || "[]");
    return Array.isArray(list) ? list.map((m) => String(m).trim().toUpperCase()) : [];
  } catch {
    return [];
  }
}

// Sidebar ka "Pathology Lab" aur OPD/IPD ke "Send to Lab" — kise dikhe?
//   lab judi ho  AUR  (hospital admin  YA  Pathology module ka koi adhikar)
// ⚠️ HMS module ka "sab khol do" wala chhata yahan JAAN-BOOJHKAR nahi — backend bhi HMS
//    wale ko lab nahi deta; link dikhta aur ticket 403 deta.
export function canOpenLab() {
  if (!labLinkEnabled()) return false;
  if (sessionStorage.getItem("isHospitalAdmin") === "1") return true;
  return allowedModules().includes("PATHOLOGY");
}

// Sirf Pathology hai, aur kuch nahi — login ke baad seedha lab (Login.jsx)
export function isPathologyOnly() {
  if (!labLinkEnabled()) return false;
  if (sessionStorage.getItem("isHospitalAdmin") === "1") return false;
  const mods = allowedModules().filter(Boolean);
  return mods.length > 0 && mods.every((m) => m === "PATHOLOGY");
}

function windowName() {
  return "labsurex_" + (sessionStorage.getItem("hospitalId") || "h");
}

// Lab kholo. purpose: "open" | "case" ({visitType:"OPD"|"IPD", visitId}) | "reports" ({uhid})
//   sameTab: true = isi tab me (sirf-Pathology user ki landing)
// Waapas: null (khul gaya) ya galti ka sandesh (string) — screen dikhaye.
export async function openLab({ purpose = "open", visitType, visitId, uhid, sameTab = false } = {}) {
  // Click ke turant baad — popup blocker se pehle. Lab ka tab pehle se khula ho to wahi
  // milta hai (naya nahi) — galti par use band NAHI karna, usme user ka kaam chal raha hai.
  const opened = sameTab ? null : window.open("", windowName());
  let fresh = false;
  try { fresh = !!opened && opened.location.href === "about:blank"; } catch { fresh = false; }
  const tab = fresh ? opened : null;

  try {
    const res = await customFetch("/LabLink/ticket", {
      method: "POST",
      body: JSON.stringify({ purpose, visitType, visitId, uhid }),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      if (tab) tab.close();
      return readServerMessage(txt, "The lab could not be opened. Please try again.");
    }

    const data = await res.json();
    if (!data?.action || !data?.ticket) {
      if (tab) tab.close();
      return "The lab could not be opened. Please try again.";
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.action;
    form.target = sameTab ? "_self" : windowName();
    form.style.display = "none";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "ticket";
    input.value = data.ticket;
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
    form.remove();
    try { opened?.focus(); } catch { /* cross-origin tab — browser khud aage laata hai */ }
    return null;
  } catch (err) {
    if (tab) tab.close();
    // customFetch 401 par khud login par bhej deta hai
    return err?.message === "Session Expired" ? null : "The lab could not be opened. Please try again.";
  }
}
